import { TextField } from "@mui/material";
import { useAuthContext } from "../Auth";

function PageUserProfile() {
  const auth = useAuthContext();
  if (!auth.userDetails || ! auth.user) {
    return <p>No user logged in</p>;
  }

  return (
    <div className="mx-auto p-6 rounded-lg shadow-lg bg-white max-w-sm">
      <h1 className="text-2xl mt-0 mb-10 text-gray-500">Mein Profil</h1>
      <form>
        <TextField className="w-full mb-3" disabled value={auth.user.email!} id="TextFieldEmail" label="E-Mailadresse" type="text"/>
        <TextField className="w-full mb-3" disabled value={auth.userDetails.firstname} id="TextFieldFirstName" label="Vorname" type="text"/>
        <TextField className="w-full mb-3" disabled value={auth.userDetails.lastname} id="TextFieldLastName" label="Nachname" type="text"/>
        <TextField className="w-full mb-3" disabled value={auth.user.phoneNumber} id="TextFieldPhone" label="Telefon" type="text"/>
      </form>
    </div>
  );
}
export default PageUserProfile;
